import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import NavigationDrawer from "react-md/lib/NavigationDrawers";
import { Toolbar } from "react-md";
import { CircleSpinner } from "react-spinners-kit";
import { icons } from "./assets/icons";
import { FontIcon } from "react-md";
import { Button } from "react-md";

import { version } from '../../package.json';

import firebase from "firebase/app";

import App from "./App";

// DUMMY PAGES
import NavItemLink from "./NavItemLink";
import Inbox from "./Inbox";
import Settings from "./Settings";

// Dashboard Page
import Dashboard from "./Dashboard";

import { withSnackbar } from "notistack";
import TanksManager from "./TanksManager";

//Global Variables
var clientInfo, sensorsArray;

//Main router with sub Routes that sends props to the router components before map
//By doing that its possible to customize each route with specific props coming from the backend or other components
const RouteWithSubRoutes = route => (
  <Route
    path={route.to}
    render={props => <route.component {...props} sensorId={route.props} />}
  />
);

class Home extends Component {
  constructor() {
    super();
    this.state = {
      navItems: [],
      loaded: false,
      spinner: true,
      weatherIcon: "na"
    };
  }

  componentWillUnmount = () => {
    this.setState({ loaded: false, spinner: true });
  };

  //call the action
  componentWillMount = () => {
    this.getWeather();
  };

  getWeather = () => {
    // APIXU API
    // --- ADD YOUR APIXU API KEY ----- // DEPRECATED
    // axios
    //   .get(
    //     "http://api.weatherstack.com/forecast?access_key=ba6d8c56ce7cbf10b6be9676c571b454&query=Bermuda"
    //   )
    //   .then(response => {
    //     //console.log the FULL response
    //     console.log('home', response);
    //     //call the function that changes the state of the weatherIcon based on icon code from ./actions/icons.js
    //     //so the icon on the navbar will be dynamic
    //     this.getIcon(response.data.current.weather_code);
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   });
  };

  //this function changes the icon on the navbar to the current weather icon
  getIcon = icon => {
    const icoClass = icons[icon];
    if (icoClass) {
      this.setState({ weatherIcon: icoClass });
    }
    return "na";
  };

  async componentDidMount() {
    // Need to set the renderNode since the drawer uses an overlay, default from react-md
    this.dialog = document.getElementById("drawer-routing-example-dialog");

    //Getting the config tank props from the url path
    //ADD a "login" page that gets only the ID and search for the config properties on firebase)
    //let clientId = this.props.clientId.params.clientId;
    let uid = await firebase.auth().currentUser.uid;

    //Get User Information
    await firebase
      .database()
      .ref("/storage/users")
      .child(uid)
      .on("value", async snapshot => {
        clientInfo = await snapshot.val();
        this.setState({ navItems: [] });

        if (!clientInfo) {
          return this.goToPage(`/`);
        }

        //Get Sensors Array and create links with them
        if (clientInfo.sensors) {
          sensorsArray = await Object.values(clientInfo.sensors);
        } else {
          this.goToPage(`/account-settings`);
        }

        if (clientInfo) {
          this.setState({ clientInfo: clientInfo, clientTanks: sensorsArray });

          // Creating new home item in NavItems
          let createNewHome = {
            label: "Dashboard Overview",
            to: "/dashboard",
            exact: true,
            icon: "home_work",
            component: Dashboard,
            mark: ""
          };
          await this.state.navItems.push(createNewHome);
          /////
        } else {
          return this.goToPage(`/`);
        }

        if (sensorsArray) {
          await sensorsArray.forEach(element => {
            //1. creating a new object
            let links = {
              label: element.sensorName,
              props: element.sensorId,
              to: `/sensor/${element.sensorId}`,
              icon: "wifi",
              component: App,
              mark: "#4CAF50"
            };

            //2. copy the original state
            let copy = Array.from(this.state.navItems);

            //3. push the new task into copy
            copy.push(links);

            //4. return the copy to replace the original state
            this.setState({
              navItems: copy
            });
          });
        }

        let settings = {
          label: "Account Settings",
          to: `/account-settings`,
          icon: "settings",
          component: Settings,
          mark: ""
        };

        await this.state.navItems.push(settings);

        let tanksManager = {
          label: "My Sensors",
          to: `/my-sensors`,
          icon: "settings",
          component: TanksManager,
          mark: ""
        };

        await this.state.navItems.push(tanksManager);

        let weather = {
          label: "Weather Forecast",
          to: "/weather-forecast",
          exact: true,
          icon: "cloud_queue",
          component: Inbox,
          mark: ""
        };
        await this.state.navItems.push(weather);

        //run first time app loads
        if (sensorsArray) {
          await sensorsArray.forEach(element => {
            setTimeout(
              function() {
                this.getSensorStatus(element.sensorId);
              }.bind(this),
              0
            );
          });
        }

        await this.setState({ loaded: true, spinner: false });
      });
  }

  async getSensorStatus(sensorId) {
    let inactiveSensors = [];
    await firebase
      .database()
      .ref("/sensors/" + sensorId + "/logs/")
      .limitToLast(1)
      .once("child_added", function(snap) {
        let item = snap.val();
        if (Date.now() - 7200000 > item.timestamp || !item.timestamp) {
          inactiveSensors.push(sensorId);
        }
      });

    if (inactiveSensors.length > 0) {
      inactiveSensors.forEach(element => {
        this.tankStatusMark(element);
      });
    }
  }

  //Change the sensor marker rightIcon on the Drawer
  tankStatusMark = sensorId => {
    //notistack snackbar functionality
    this.props.enqueueSnackbar(sensorId + " offline", { variant: "error" });
    this.state.navItems.forEach(element => {
      if (element.props === sensorId) {
        element.mark = "#F44336";
        this.setState({
          navItems: this.state.navItems,
          element
        });
      }
    });
  };

  goToPage = path => {
    this.props.history.push(path);
  };

  render() {
    const routelists = this.state.navItems;
    if (this.state.loaded) {
      return (
        <Route
          render={({ location }) => (
            <NavigationDrawer
              toolbarChildren={
                <div>
                  {/* <i
                    style={{
                      position: "absolute",
                      left: "240px",
                      fontSize: "25px",
                      top: "27%"
                    }}
                    className={`wi ${this.state.weatherIcon}`}
                  ></i> */}
                  <Button
                    onClick={() => firebase.auth().signOut()}
                    icon
                    swapTheming
                    iconEl={
                      <FontIcon
                        style={{
                          fontSize: "30px",
                          position: "absolute",
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%, -50%)"
                        }}
                      >
                        exit_to_app
                      </FontIcon>
                    }
                    style={{
                      position: "absolute",
                      right: "0px",
                      top: "0px",
                      marginTop: "0.6%",
                      marginBottom: "1%",
                      marginRight: "1%"
                    }}
                  ></Button>
                </div>
              } //ADD FONT ICON FROM API AND BUTTON TO FORECAST
              drawerTitle={
                <Toolbar
              title={<div style={{margin: 'auto 60%'}}><small style={{position: 'absolute', marginTop: '15px', fontSize:'10px'}}>v{version}</small><img src={"../lettering_blue.png"} alt="logo" height="18" /></div>}
                  //className="md-divider-border"
                />
              }
              toolbarTitle={this.state.clientInfo.fullName + " Dashboard"}
              desktopDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
              navItems={routelists.map(props => (
                <NavItemLink {...props} key={props.to} />
              ))}
            >
              {/*Mapping route with props using subroutes component from Route*/}
              <Switch key={location.key}>
                {routelists.map((route, key) => (
                  <RouteWithSubRoutes key={key} path={route.to} {...route} />
                ))}
              </Switch>
            </NavigationDrawer>
          )}
        />
      );
    } else {
      return (
        // Loading spinner...
        <div className="spinner">
          <CircleSpinner
            size={50}
            color="#2196F3"
            loading={this.state.spinner}
          />
        </div>
      );
    }
  }
}

export default withRouter(withSnackbar(Home));
